<!--
https://auth0.com/blog/beginner-vuejs-tutorial-with-user-login/
-->
<template>
  <div id="app">
    <nav1 v-if="showNavFooter"></nav1>
    <router-view @view-loaded="viewLoaded" @hide-footer="hideFooter" v-slot="{ Component }">
      <transition name="slide-left">
        <component :is="Component" />
      </transition>
    </router-view>
    <myfooter id="myfooter" ref="refChgActiveItem" v-if="showNavFooter"></myfooter>
  </div>
</template>

<script>
import  { ref } from 'vue'
import { useStore } from 'vuex'
import Nav from '@/components/Nav.vue'
import Footer from '@/components/Footer.vue'
import $ from 'jquery'
//import {Toast} from 'vant'
export default {
//  emits: ['viewChanged'],
  props: {
    hid: {
      type: String,
      default:'category'
    }
  },
  
  computed: {
    showNavFooter() {
      return this.$store.getters.showNav
    }
  },
  
  setup() {
    const store = useStore()
    const refChgActiveItem = ref()
    const viewLoaded = (fid) => {
  //    refChgActiveItem.value.chgActiveItem(fid)
    refChgActiveItem.value = fid
    }

    const hideFooter = () => {
      $('#myfooter').hide()
    }
    store.commit('showNav',true)

    return {viewLoaded, hideFooter, refChgActiveItem}
  },
  components: {'nav1': Nav,'myfooter':Footer}
}
</script>



<style lang="scss">
#app {
  margin-left:auto;margin-right:auto;
  height:100vh;
  font-family: normal 100% Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
@media only screen and (max-width:600px) {
  #app {
    width:100%;
  }
}
@media only screen and (min-width:600px) {
  #app {
    width: 400px;
  }
}


#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.c-red {color:#dc3545;}
</style>
